// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2e0Gx","addWidgetButton":"Header_addWidgetButton__iSZ-m","dashboardTabs":"Header_dashboardTabs__1Qc4s","active":"Header_active__2omI9"};